export enum MarketSyncState {
  Pending = "pending",
  Calculating = "calculating",
  Publishing = "publishing",
  Complete = "complete",
  Failed = "failed",
  Cancelled = "cancelled",
}
